<ng-container *cmLet="(getPrimaryActions | thunk : actions : groupStart) as primaryActions">
  <button
    *ngFor="let action of primaryActions"
    (click)="onActionClick(action.type)"
    type="button"
    class="action btn btn-primary sm-padding"
    [attr.data-id]="action.dataId"
    [disabled]="disabled || action.disabled">
    {{action.name}}
  </button>
</ng-container>

<ng-container *cmLet="(getGroupedActions | thunk : actions : groupStart) as groupedActions">
  <div ngbDropdown *ngIf="groupedActions.length" [placement]="['bottom-right', 'auto']">
    <button class="btn btn-primary btn-toggle sm-padding" id="{{id}}" ngbDropdownToggle [disabled]="disabled">
      <span class="fa fa-ellipsis-h"></span>
    </button>

    <div ngbDropdownMenu [attr.aria-labelledby]="id">
      <button
        *ngFor="let action of groupedActions"
        class="dropdown-item"
        (click)="onActionClick(action.type)"
        [attr.data-id]="action.dataId"
        [disabled]="disabled">
        {{action.name}}
      </button>
    </div>
  </div>
</ng-container>
